import { useAppMutation } from '@/shared/hooks/useAppMutation'
import { ProjectEntity } from '@/shared/lib/db'
import { AppError } from '@/shared/types/AppError'
import { HookOptions } from '@/shared/types/HookOptions'
import { useQuery } from '@tanstack/react-query'
import { projectService } from '../services/project.service'

export const projectKeys = {
    all: ['projects'] as const,
    detail: (id: string) => [...projectKeys.all, id] as const,
}

export const useProjectsQuery = (userId?: string) => {
    return useQuery({
        queryKey: projectKeys.all,
        queryFn: () => projectService.getAll(),
        select: (data) => (userId ? data.filter((p) => p.userId === userId) : data),
    })
}

export const useProjectQuery = (id: string | undefined) => {
    return useQuery({
        queryKey: projectKeys.detail(id!),
        queryFn: () => projectService.get(id!),
        enabled: !!id,
    })
}

export const useCreateProjectMutation = (options?: HookOptions<void, AppError, ProjectEntity>) => {
    return useAppMutation<void, AppError, ProjectEntity>({
        mutationFn: (project: ProjectEntity) => projectService.save(project),
        invalidateKeys: [projectKeys.all],
    }, options)
}

export const useUpdateProjectMutation = (options?: HookOptions<void, AppError, ProjectEntity>) => {
    return useAppMutation<void, AppError, ProjectEntity>({
        mutationFn: (project: ProjectEntity) => projectService.save(project),
        invalidateKeys: [projectKeys.all],
    }, options)
}

export const useDeleteProjectMutation = (options?: HookOptions<void, AppError, string>) => {
    return useAppMutation<void, AppError, string>({
        mutationFn: (id: string) => projectService.delete(id),
        invalidateKeys: [projectKeys.all],
    }, options)
}
